import { ValidateUtils } from 'utils';
import { trimText } from 'utils/StringUtils';

const validateForm = ({
  companyName,
  taxCode,
  mst,
  translateAlertAction,
  onSetError,
  ...invoice
}) => {
  const { province, district, ward, isUseCustom, postCode, streetAddress } = invoice || {};
  if (ValidateUtils.isEmpty(trimText(companyName))) {
    const companyNameElement = document.getElementById('companyName');
    if (companyNameElement) {
      companyNameElement.focus();
    }
    onSetError('companyName', true);
    throw Error(translateAlertAction('message_empty_company_name'));
  }
  if (trimText(companyName).length <= 2)
    throw Error(translateAlertAction('message_valid_company_name'));
  if (ValidateUtils.isEmpty(taxCode || mst)) {
    const taxCodeElement = document.getElementById('taxCode');
    if (taxCodeElement) {
      taxCodeElement.focus();
    }
    onSetError('taxCode', true);
    throw Error(translateAlertAction('message_empty_tax_code'));
  }

  // if (!ValidateUtils.isNumber(mst)) throw Error('Mã số thuế sai định dạng');
  const mstError = ValidateUtils.validateMst(taxCode || mst) || '';
  if (mstError) throw Error(translateAlertAction(`${mstError}`));

  if (isUseCustom) {
    if (ValidateUtils.isEmpty(streetAddress)) {
      onSetError('streetAddress', true);
      throw Error(translateAlertAction('message_empty_street_address'));
    } else if (ValidateUtils.isEmpty(province)) {
      onSetError('province', true);
      throw Error(translateAlertAction('message_empty_province_city'));
    } else if (ValidateUtils.isEmpty(district)) {
      onSetError('district', true);
      throw Error(translateAlertAction('message_empty_district'));
    } else if (ValidateUtils.isEmpty(ward)) {
      onSetError('ward', true);
      throw Error(translateAlertAction('message_empty_ward'));
    }
  }

  if (ValidateUtils.isEmpty(postCode)) {
    const postCodeElement = document.getElementById('postCode');
    if (postCodeElement) {
      postCodeElement.focus();
    }
    onSetError('postCode', true);
    throw Error(translateAlertAction('message_empty_post_code'));
  }

  // Truong Phan confirm
  // if (mst.length !== 10 && mst.length !== 14) throw Error('Mã số thuế phải có 10 hoặc 14 số');
};

export default validateForm;
